import React from 'react';

export interface ResponsiveGridProps {
  children: React.ReactNode;
  /** Number of columns at sm breakpoint */
  sm?: number;
  /** Number of columns at md breakpoint */
  md?: number;
  /** Number of columns at lg breakpoint */
  lg?: number;
  /** Gap between grid items (CSS value, default: '1rem') */
  gap?: string;
  /** Additional CSS class names */
  className?: string;
}

/**
 * CSS Grid wrapper with mobile-first column configuration.
 * Always 1 column on xs; columns increase at specified breakpoints.
 */
export function ResponsiveGrid({
  children,
  sm,
  md,
  lg,
  gap,
  className = '',
}: ResponsiveGridProps) {
  const classes = [
    'ipa-responsive-grid',
    sm ? `ipa-responsive-grid--sm-${sm}` : '',
    md ? `ipa-responsive-grid--md-${md}` : '',
    lg ? `ipa-responsive-grid--lg-${lg}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style = gap ? { gap } : undefined;

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}
